import { UserInfo, ConversationRequest, Conversation, ChatMessage, CosmosDBHealth, CosmosDBStatus,
    HideCitations, FeedbackRequest, ShowMsgFb, SpeechAuth, BlobListItem,
    AssignUserToProgramResponse } from "./models";
import { AuthenticationResult } from "@azure/msal-browser";
import { v4 as uuidv4 } from 'uuid';
import { getAccessToken, getB2CClaims, getSessionToken, setSessionToken, getCachedSessionToken } from "../utils/token";
import { getEnvContext } from "../utils/envContext";

export async function getSpeechAuthToken(): Promise<SpeechAuth|void> {
    const response = await fetch('/speech/issueToken');
    if (!response.ok) {
        console.log("Can't retrieve access token, speech will be disabled.")
        return;
    }

    const payload = await response.json();
    return payload;
}
// export async function gethideCitations(): Promise<HideCitations> {
//     const response = await fetch("/showHideCitations", {
//         method: "GET"
//     })
//     .then(async res => {
//         let respJson = await res.json();
//         let formattedResponse;
//         if(respJson.hideCitations){
//             formattedResponse = respJson.hideCitations
//         }else{
//             formattedResponse = "false"
            
//         }
         
//         if(!res.ok){
//             return {
//                 hideCitations: "false"
//             }
//         }else{
//             return {
//                 hideCitations: formattedResponse
//             }
//         }
//     })
//     .catch((err) => {
//         console.log(err)
//         console.error("Hide/Show Citation issue.");
//         return {
//             hideCitations: "false"
//         }
//     })
//     return response;
// }

// export async function gethideMsgFb(): Promise<ShowMsgFb> {
//     const response = await fetch("/showHideMsgFb", {
//         method: "GET"
//     })
//     .then(async res => {
//         let respJson = await res.json();
//         let formattedResponse;
//         if(respJson.showMsgFb){
//             formattedResponse = respJson.showMsgFb
//         }else{
//             formattedResponse = "false"
            
//         }
         
//         if(!res.ok){
//             return {
//                 showMsgFb: "false"
//             }
//         }else{
//             return {
//                 showMsgFb: formattedResponse
//             }
//         }
//     })
//     .catch((err) => {
//         console.log(err)
//         console.error("Hide/Show Msg Fb issue.");
//         return {
//             showMsgFb: "false"
//         }
//     })
//     return response;
// }

 
export async function conversationApi(options: ConversationRequest, abortSignal: AbortSignal): Promise<Response> {
    const response = await fetch("/conversation", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            messages: options.messages,
            //sessionUUID: options.sessionUUID,
            chatUUID: options.chatUUID
        }),
        signal: abortSignal
    });

    return response;
}

export async function getUserInfo(): Promise<UserInfo[]> {
    const response = await fetch('/.auth/me');
    if (!response.ok) {
        console.log("No identity provider found. Access to chat will be blocked.")
        return [];
    }

    const payload = await response.json();
    return payload;
}
 
    
export const historyList = async (offset=0): Promise<Conversation[] | null> => {
    //console.log("In history LIST")
    const response = await fetch(`/history/list?offset=${offset}`, {
        method: "POST",
        body: JSON.stringify({
            user_id: sessionStorage.sessionUUID
        }),
        headers: {
            "Content-Type": "application/json"
        },
    }).then(async (res) => {
        const payload = await res.json();
        if (!Array.isArray(payload)) {
            console.error("There was an issue fetching your data.");
            return null;
        }
         
        const conversations: Conversation[] = await Promise.all(payload.map(async (conv: any) => {
            
            let convMessages: ChatMessage[] = [];
            convMessages = await historyRead(conv.id, conv.userId)
            .then((res) => {
                return res
            })
            .catch((err) => {
                console.error("error fetching messages: ", err)
                return []
            })
            const conversation: Conversation = {
                id: conv.id,
                title: conv.title,
                date: conv.createdAt,
                messages: convMessages
            };
            return conversation;
        }));
        return conversations;
    }).catch((err) => {
        console.log(err)
        console.error("There was an issue fetching your data.");
        return null
    })

    return response
}
    
export const historyRead = async (convId: string, userId: string): Promise<ChatMessage[]> => {
    const response = await fetch("/history/read", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            user_id: userId
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then(async (res) => {
        if(!res){
            return []
        }
        const payload = await res.json();
        let messages: ChatMessage[] = [];
        if(payload?.messages){
            payload.messages.forEach((msg: any) => {
                const message: ChatMessage = {
                    id: msg.id,
                    role: msg.role,
                    date: msg.createdAt,
                    content: msg.content,
                    context: { followup_questions: null },
                    prompt_tokens: Number(msg.prompt_tokens) || 0, //Number(sessionStorage.getItem("promptTokenCount")),
                    completion_tokens: Number(msg.completion_tokens) || 0,
                    feedbackOnMsg: msg.feedbackOnMsg?? undefined 
                }
                messages.push(message)
            });
        }
        return messages;
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        return []
    })
    return response
}

export const requestTTS = async (msg: string, conversation_id: string, user_id: string): Promise<string | null> => {

    const language = document.documentElement.lang || "en-US";
    //console.log('requesting ' + language)
    //console.log('message: ' + msg)
    let selectProgramCode = window.sessionStorage.getItem("selectedProgramCode")
    let configCode = window.sessionStorage.getItem("selectedProgramConfig")
    return await fetch("/requestTTS", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ message: msg, language: language, conversation_id:conversation_id, user_id:user_id, program_code:selectProgramCode, config_code:configCode})
        
    }).then((res) => {
        if (res.status == 200) {
            return res.blob();
        } else if (res.status == 400) {
            console.log("Speech synthesis is not enabled.");
            return null;
        } else {
            console.error("Unable to get speech synthesis.");
            return null;
        }
    })
        .then(blob => (blob ? URL.createObjectURL(blob) : null));
    //     .catch((err) => {
    //         console.error("There was an issue in TTS.");
    //         let errorChatMsg: ChatMessage = {
    //             id: uuidv4(),
    //             role: "error",
    //             content: err,
    //             date: new Date().toISOString(),
    //             prompt_tokens: 0,
    //             completion_tokens: 0
    //         };
    //         historyLogError(errorChatMsg, cId, chatUUID,pgm);
    //         return new Response;
    //     })
    // return response
}
export const historyGenerate = async (options: ConversationRequest, abortSignal: AbortSignal, chatUUID: string, b2cAuthResponse: AuthenticationResult | null | undefined, language: string,
    isFaq: string, pgm: string,  authType: string, authFieldsVal: { [key: string]: string }, convId?: string, isStopped?: boolean, hasStoppedGenerating?: boolean, msal?: any, settings?: any, caseScope?: string ): Promise<Response> => {
    let body;
    //console.log(" in history generate " + authType + " " + authFieldsVal)
    let cId =''
    const { env, isInIframe } = getEnvContext();
    let isFirstAuthQuestion = window.sessionStorage.getItem("firstAuthQuestion");
    // console.log(`in historyGenerate: pgm: ${pgm}, isInIframe: ${isInIframe}, iFrameEnv: ${iFrameEnv}, mainEnv: ${mainEnv}`);

    const b2cClaims = getB2CClaims(b2cAuthResponse);
    const b2cOID = b2cClaims?.oid ?? '';
    const userEmail = b2cClaims?.emails?.[0] ?? '';

    const sessionToken = await getCachedSessionToken(msal, settings);
    const requestHeaders: Record<string, string> = {
        "Content-Type": "application/json",
        ...(sessionToken ? { "X-Session-Token": sessionToken } : {})
    };
    // Case-scoped questions carry the B2C token: the server takes the caller's
    // identity from it and checks the case is on their profile before any case
    // records are attached
    if (caseScope === "Y") {
        const accessToken = await getAccessToken(msal, settings);
        if (accessToken) {
            requestHeaders["Authorization"] = `Bearer ${accessToken}`;
        }
    }

    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    if(convId){
        cId = convId
        body = JSON.stringify({
            conversation_id: convId,
            messages: options.messages,
            user_id: chatUUID,
            b2cOID,
            user: userEmail,
            language: language,
            isFaq: isFaq,
            pgm: pgm,
            env,
            authType: authType.replace(/^profile/, ''),
            authFieldsVal: authFieldsVal,
            caseScope: caseScope ?? "N",
            isInIframe,
            isFirstAuthQuestion: isFirstAuthQuestion,
            isStopped: isStopped,
            hasStoppedGenerating: hasStoppedGenerating,
            config_code: configCode
        })
    }else{
        body = JSON.stringify({
            messages: options.messages,
            user_id: chatUUID,
            b2cOID,
            user: userEmail,
            language: language,
            isFaq: isFaq,
            pgm: pgm,
            env,
            authType: authType.replace(/^profile/, ''),
            authFieldsVal: authFieldsVal,
            caseScope: caseScope ?? "N",
            isInIframe,
            isFirstAuthQuestion: isFirstAuthQuestion,
            isStopped: isStopped,
            hasStoppedGenerating: hasStoppedGenerating,
            config_code: configCode
        })
    }
    const response = await fetch("/history/generate", {
        method: "POST",
        headers: requestHeaders,
        body: body,
        signal: abortSignal
    }).then((res) => {
        return res 
    })
    .catch((err) => {
        if (err.name === 'AbortError') {
            return new Response();
        }         
        console.error("There was an issue creating history.");
        const errorText = `Network error calling /history/generate: ${err?.message || err}`;
        let errorChatMsg: ChatMessage = {
            id: uuidv4(),
            role: "error",
            content: errorText,
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: 0,
            completion_tokens: 0 
        };
        historyLogError(errorChatMsg, cId, chatUUID,pgm);

    return new Response(JSON.stringify({}), { status: 500 });
    })
    return response
}


export const historyUpdate = async (messages: ChatMessage[], convId: string, chatUUID: string, b2cAuthResponse: AuthenticationResult | null | undefined, pgm: string, isStopped?:boolean, hasStoppedGenerating?: boolean, copilotFormData?: {}): Promise<Response> => {
    //console.log("In History update: this is my chat UUID: " +  chatUUID)
    const { env, isInIframe } = getEnvContext();
    let isFirstAuthQuestion = window.sessionStorage.getItem("firstAuthQuestion");

    const b2cClaims = getB2CClaims(b2cAuthResponse);
    const b2cOID = b2cClaims?.oid ?? '';
    const userEmail = b2cClaims?.emails?.[0] ?? '';

    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const response = await fetch("/history/update", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            messages: messages,
            user_id: chatUUID,
            b2cOID,
            user: userEmail,
            pgm: pgm,
            isFirstAuthQuestion: isFirstAuthQuestion,
            env,
            isInIframe,
            isStopped: isStopped,
            hasStoppedGenerating: hasStoppedGenerating,
            copilotFormData: copilotFormData,
            config_code: configCode
        }),
        headers: {
            "Content-Type": "application/json"
        },
    }).then(async (res) => {
        return res
    })
    .catch((err) => {      
        if (err.name === 'AbortError') {
            return new Response();
        }  
        console.error("There was an issue updating history.");
        const errorText = `Network error calling /history/update: ${err?.message || err}`;
        return new Response(JSON.stringify({ error: errorText }), { status: 500 });
    })
    return response
}

export const historyMessageFeedback = async (messageId: string, feedback: string, convId: string, chatUUID: string, pgm: string, b2cAuthResponse: AuthenticationResult | null | undefined): Promise<Response> => {
    const { env, isInIframe } = getEnvContext();

    const b2cClaims = getB2CClaims(b2cAuthResponse);
    const userEmail = b2cClaims?.emails?.[0] ?? '';

    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const response = await fetch("/history/message_feedback", {
        method: "POST",
        body: JSON.stringify({
            message_id: messageId,
            message_feedback: feedback,
            conversation_id: convId,
            user_id: chatUUID,
            user: userEmail,
            pgm: pgm,
            env,
            isInIframe,
            config_code: configCode
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue logging feedback.");
        return new Response(null, { status: 500 });
    })
    return response;
}
 
export const historyLogError = async (message: ChatMessage, convId: string, chatUUID: string, pgm: string): Promise<Response> => {
    //console.log("In History Log Error : this is my chat UUID: " +  chatUUID)
    const { env, isInIframe } = getEnvContext();

    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const response = await fetch("/history/logerror", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            message: message,
            user_id: chatUUID,
            pgm: pgm,
            env,
            isInIframe,
            config_code: configCode
        }),
        headers: {
            "Content-Type": "application/json"
        },
    }).then(async (res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue logging the error.");
        return new Response(null, { status: 500 });
    })
    return response
}
    
export const historyDelete = async (convId: string, chatUUID: string,pgm:string) : Promise<Response> => {
    //console.log("&&&& history delete &&&&")
    //console.log(convId)
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const response = await fetch("/history/delete", {
        method: "DELETE",
        body: JSON.stringify({
            conversation_id: convId,
            user_id: chatUUID,
            config_code: configCode
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data.");
        let errorChatMsg: ChatMessage = {
            id: uuidv4(),
            role: "error",
            content: err,
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: 0,
            completion_tokens: 0 
        };
        historyLogError(errorChatMsg,convId, chatUUID,pgm);
        return new Response(null, { status: 500 });
    })
    return response;
}
    
export const historyDeleteAll = async (chatUUID: string) : Promise<Response> => {
    //console.log("&&&& history delete all &&&&")
   
    const response = await fetch("/history/delete_all", {
        method: "DELETE",
        //body: JSON.stringify({}),
        body: JSON.stringify({
            user_id: chatUUID
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data.");
        return new Response(null, { status: 500 });
    })
    return response;
}
    
export const historyClear = async (convId: string, chatUUID: string, pgm: string) : Promise<Response> => {
    const { env, isInIframe } = getEnvContext();
    window.sessionStorage.removeItem("firstAuthQuestion");
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const response = await fetch("/history/clear", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            user_id: chatUUID,
            env,
            isInIframe,
            config_code: configCode
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data.");
        let errorChatMsg: ChatMessage = {
            id: uuidv4(),
            role: "error",
            content: `Network error calling /history/clear: ${err?.message || err}`,
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: 0,
            completion_tokens: 0 
        };
        historyLogError(errorChatMsg,convId, chatUUID,pgm);
        return new Response(null, { status: 500 });
    })
    return response;
}
    
export const historyRename = async (convId: string, title: string, chatUUID: string,pgm: string) : Promise<Response> => {
    const response = await fetch("/history/rename", {
        method: "POST",
        body: JSON.stringify({
            conversation_id: convId,
            title: title,
            user_id: chatUUID,
            pgm:pgm
        }),
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        return res
    })
    .catch((err) => {
        console.error("There was an issue fetching your data.");
        return new Response(null, { status: 500 });
    })
    return response;
}
    
export const historyEnsure = async (): Promise<CosmosDBHealth> => {
    const response = await fetch("/history/ensure", {
        method: "GET",
    })
    .then(async res => {
        let respJson = await res.json();
        let formattedResponse;
        if(respJson.message){
            formattedResponse = CosmosDBStatus.Working
        }else{
            if(res.status === 500){
                formattedResponse = CosmosDBStatus.NotWorking
            }else{
                formattedResponse = CosmosDBStatus.NotConfigured
            }
        }
        if(!res.ok){
            return {
                cosmosDB: false,
                status: formattedResponse,
                allowMessageDelete: "false"
            }
        }else{
            return {
                cosmosDB: true,
                status: formattedResponse,
                allowMessageDelete: respJson.allowMessageDelete
            }
        }
    })
    .catch((err) => {
        console.log(err)
        console.error("There was an issue fetching your data.");
        return {
            cosmosDB: false,
            status: err,
            allowMessageDelete: "false"
        }
    })
    return response;
}
export const load = async (): Promise<Response | null> => {

    const response = await fetch("/load", {
        method: "GET",
    }).then((res) => {
        return res.json()
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        return null
    })

    return response
}
export const feedbackGenerate = async (options: FeedbackRequest, abortSignal: AbortSignal, chatUUID: string, convId: string,pgm:string, b2cAuthResponse: AuthenticationResult | null | undefined): Promise<Response> => {
    let body;
    const { env, isInIframe } = getEnvContext();
    const b2cClaims = getB2CClaims(b2cAuthResponse);
    const userEmail = b2cClaims?.emails?.[0] ?? '';

    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    body = JSON.stringify({
            conversation_id: convId,
            message: options.message,
            user_id: chatUUID,
            user: userEmail,
            pgm: pgm,
            env,
            isInIframe,
            config_code: configCode
    })
    
    const response = await fetch("/feedback/generate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: body,
        signal: abortSignal
    }).then((res) => {
        return res 
    })
    .catch((err) => {
        console.error("There was an issue saving feedback.");
        let errorChatMsg: ChatMessage = {
            id: uuidv4(),
            role: "error",
            content: `Network error calling /feedback/generate: ${err?.message || err}`,
            context: { followup_questions: null },
            date: new Date().toISOString(),
            prompt_tokens: 0,
            completion_tokens: 0 
        };
        historyLogError(errorChatMsg, convId, chatUUID,pgm);
        return new Response(null, { status: 500 });
    })
    return response
}

export const fetchAndStoreSessionToken = async (msal: any, settings: any): Promise<void> => {
    const accessToken = await getAccessToken(msal, settings);

    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
    };
    const sessionToken = getSessionToken();
    if (sessionToken) {
        headers["X-Session-Token"] = sessionToken;
    }
    const response = await fetch("/auth/session", {
        method: "POST",
        headers,
    }).then((res) => res.json()).catch((err) => {
        console.error("Error refreshing session token:", err);
        return null;
    });
    if (response?.session_token) {
        const tokenExpiration = JSON.parse(atob(response.session_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp;
        setSessionToken(response.session_token, tokenExpiration);
    }
}

export const frontendSettings = async (msal: any, settings: any): Promise<Response | null> => {
    const accessToken = await getAccessToken(msal, settings);
    const cachedSessionToken = await getCachedSessionToken(msal, settings);
    window.sessionStorage.removeItem("firstAuthQuestion");

    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
    };

    // Only send session token if a Bearer token is also present — the backend requires both together.
    if (cachedSessionToken && accessToken) {
        headers["X-Session-Token"] = cachedSessionToken;
    }

    const response = await fetch("/frontend_settings", {
        method: "GET",
        headers,
    }).then((res) => {
        return res.json()
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        return null
    })

    return response
}
export const refreshfrontendSettings = async (pgm: string, language: string, program_code: string | null, msal: any, settings: any): Promise<Response | null> => { 
    //console.log("IN REFRESH FRONTEND SETTINGS: this is pgm: " + pgm)  
    const accessToken = await getAccessToken(msal, settings);
    const cachedSessionToken = await getCachedSessionToken(msal, settings);
    window.sessionStorage.removeItem("firstAuthQuestion"); 

    const user_id = window.sessionStorage.getItem("sessionUUID") || ''; 
    let isInIframe = window.sessionStorage.getItem("isInIframe") || ''; 
    if (isInIframe === 'true') {
        window.sessionStorage.setItem("iframe_env", pgm);
    } else {
        window.sessionStorage.setItem("main_env", pgm);
    }
    // console.log(`pgm in refreshfrontendSettings: ${pgm}, isInIframe: ${isInIframe}`);

    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
    };

    // Only send session token if a Bearer token is also present — the backend requires both together.
    if (cachedSessionToken && accessToken) {
        headers["X-Session-Token"] = cachedSessionToken;
    }


    const response = await fetch(`/refresh_frontend_settings/${pgm}?program_code=${program_code}&user_id=${user_id}`, {
        method: "GET",
        headers
    }).then((res) => {
        return res.json()
    }).catch((err) => {
        console.error("There was an issue fetching your data.");
        return null
    })

    return response
}
export const refreshEnv = async (pgm: string): Promise<Response> => {
    //console.log("In refresh env: this is pgm: " + pgm)
    const response = await fetch("/env/" + pgm, {
        method: "GET",
    }).then(async (res) => {
        return res
    })
        .catch((err) => {
            console.error("There was an issue refreshing env. " + err);

            return new Response(null, { status: 500 });
        })
    return response
}

export const pii_redaction = async (q: string, language: string,pgm: string, conversation_id:string,user_id:string): Promise<Response> => {
    const { env, isInIframe } = getEnvContext();
    
    let body;
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    body = JSON.stringify({
        question: q,
        language: language,
        env,
        isInIframe,
        pgm: pgm,
        conversation_id: conversation_id,
        user_id: user_id,
        config_code: configCode
    })

    const response = await fetch("/pii_recognition", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: body,
    }).then(async (res) => {
        return res
    })
        .catch((err) => {
            console.error("There was an issue in pii redaction. " + err);

            return new Response(null, { status: 500 });
        })
    return response
}


export const summaryGenerate = async (options: ConversationRequest, chatUUID: string, pgm: string, convId: string): Promise<Response> => {
    let body;
    //console.log(" in summary generate")
    const { env, isInIframe } = getEnvContext();
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    body = JSON.stringify({
        conversation_id: convId,
        messages: options.messages,
        user_id: chatUUID,
        pgm: pgm,
        env,
        isInIframe,
        config_code: configCode
    })


    const response = await fetch("/summary/generate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: body
    }).then((res) => {
        return res
    })
        .catch((err) => {
            console.error("There was an issue creating summary. " + err);
            let errorChatMsg: ChatMessage = {
                id: uuidv4(),
                role: "error",
                content: `Network error calling /summary/generate: ${err?.message || err}`,
                context: { followup_questions: null },
                date: new Date().toISOString(),
                prompt_tokens: 0,
                completion_tokens: 0
            };
            historyLogError(errorChatMsg, convId, chatUUID, pgm);
            return new Response(null, { status: 500 });
        })
    return response
}


export const signOnValidate = async (authFieldsVal: { [key: string]: string }, authType:string ,chatUUID: string, pgm: string, convId: string, b2cAuthResponse: object, hasInternalPrograms: boolean, msal: any, settings: any): Promise<Response> => {
    let body;
    let user_id = window.sessionStorage.getItem("sessionUUID") || "";
    let selectProgramCode = window.sessionStorage.getItem("selectedProgramCode")
    const { env, isInIframe } = getEnvContext();
    if (chatUUID === "" && user_id !== "") {
        chatUUID = user_id;
    }
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const accessToken = await getAccessToken(msal, settings);
    body = JSON.stringify({
        conversation_id: convId,
        user_id: chatUUID,
        pgm: pgm,
        authType: authType,
        authFieldsVal: authFieldsVal,
        b2cAuthResponse: b2cAuthResponse,
        env,
        isInIframe,
        program_code: selectProgramCode,
        has_internal_programs: hasInternalPrograms,
        config_code: configCode
    })


    const response = await fetch("/signon/validate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
        },
        body: body
    }).then((res) => {
        return res
    })
        .catch((err) => {
            console.error("There was an issue getting sign on profile. " + err);
          
            return new Response(null, { status: 500 });
        })
    return response
}

export const assignExternalProgram = async (
    authFieldsVal: { [key: string]: string },
    programCode: string,
    env: { iframe_env: string | null; main_env: string | null },
    isInIframe: string | null,
    b2cAuthResponse: object | null,
    hasInternalPrograms: boolean,
    msal: any,
    settings: any
): Promise<Response> => {
    const accessToken = await getAccessToken(msal, settings);
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const body = JSON.stringify({
        authFieldsVal,
        program_code: programCode,
        env,
        isInIframe,
        b2cAuthResponse: b2cAuthResponse || {},
        has_internal_programs: hasInternalPrograms,
        config_code: configCode
    });
    return fetch("/assign_external_program", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
        },
        body
    }).catch(err => {
        console.error("Error assigning external program: " + err);
        return new Response();
    });
};

export const removeExternalProgram = async (
    authFieldsVal: { [key: string]: string },
    programCode: string,
    env: { iframe_env: string | null; main_env: string | null },
    isInIframe: string | null,
    b2cAuthResponse: object | null,
    hasInternalPrograms: boolean,
    msal: any,
    settings: any
): Promise<Response> => {
    const accessToken = await getAccessToken(msal, settings);
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const body = JSON.stringify({
        authFieldsVal,
        program_code: programCode,
        env,
        isInIframe,
        b2cAuthResponse: b2cAuthResponse || {},
        has_internal_programs: hasInternalPrograms,
        config_code: configCode
    });
    return fetch("/remove_external_program", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
        },
        body
    }).catch(err => {
        console.error("Error removing external program: " + err);
        return new Response();
    });
};

export const removeCase = async (
    authFieldsVal: { [key: string]: string },
    caseNumber: string,
    env: { iframe_env: string | null; main_env: string | null },
    isInIframe: string | null,
    b2cAuthResponse: object | null,
    hasInternalPrograms: boolean,
    msal: any,
    settings: any
): Promise<Response> => {
    const accessToken = await getAccessToken(msal, settings);
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const body = JSON.stringify({
        authFieldsVal,
        case_number: caseNumber,
        env,
        isInIframe,
        b2cAuthResponse: b2cAuthResponse || {},
        has_internal_programs: hasInternalPrograms,
        config_code: configCode
    });
    return fetch("/remove_case", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
        },
        body
    }).catch(err => {
        console.error("Error removing external case: " + err);
        return new Response();
    });
};

export const validateIVRCredentials = async (ssn: string, dob: string, authType:string ,chatUUID: string, pgm: string, convId: string): Promise<Response> => {
  let body;
    
  const { env, isInIframe } = getEnvContext();
  let user_id = window.sessionStorage.getItem("sessionUUID") || "";
  let selectProgramCode = window.sessionStorage.getItem("selectedProgramCode")
  if (chatUUID === "" && user_id !== "") {
        chatUUID = user_id;
    }
  const configCode = window.sessionStorage.getItem("selectedProgramConfig")
  body = JSON.stringify({
    conversation_id: convId,
    user_id: chatUUID,
    pgm: pgm,
    authType: authType,
    ssn: ssn,
    dob: dob,
    env,
    isInIframe,
    program_code: selectProgramCode,
    config_code: configCode
  })
  try {
    const response = await fetch("/signon/validateIVR", { 
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: body
    });
    
    const data = await response.json();

    if (data.error || data.authorized === false) {
      return new Response(JSON.stringify(data), {
        status: data.status_code || 401,
        headers: { 'Content-Type': 'application/json' }
      });
    }
    
    return new Response(JSON.stringify(data), {
      status: response.status,
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (err) {
    console.error("There was an issue validating IVR credentials. " + err);
    return new Response(JSON.stringify({ 
      error: "Network error", 
      authorized: false, 
      status_code: 500 
    }), {
      status: 500,
      headers: { 'Content-Type': 'application/json' }
    });
}
}

export const fetchCSSConfig = async (connection_string: string, main_api: string, is_dark_mode: boolean, configCode: string) => {
    let user_id = window.sessionStorage.getItem("sessionUUID") || "";
    let selectProgramCode = window.sessionStorage.getItem("selectedProgramCode")
    const response = await fetch(`${main_api}config_css`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            app_connection: connection_string? connection_string : 'invalid',
            is_dark_mode:is_dark_mode, 
            user_environment_name:configCode+'-User',
            user_id:user_id, 
            program_code:selectProgramCode })
    });
    const {config} = await response.json();
    applyCSSConfig(config);
};

const applyCSSConfig = (config: Record<string, any>) => {
    const root = document.documentElement;

    if (!config) {
        return;
    }

    const defaults = Object.entries(config)
    .filter(([key, value]) => key.includes('Defaults'))
    .reduce((acc, [key, value]) => {
        if (typeof value === 'object' && value !== null) {
            return { ...acc, ...value };
        } else {
            console.error(`Expected an object but got ${typeof value} for key ${key}`);
            return acc;
        }
    }, {});

    if (defaults){
        for (const [key, value] of Object.entries(defaults)) {
            root.style.setProperty(`--${key.replace('_CustomCSS', '')}`, value as string);
        }
    }

    for (const [key, value] of Object.entries(config)) {
        if (key.startsWith('YW_CustomCSS') && key !== 'YW_CustomCSS_Defaults') {
            if (value != 'invalid'){
                const newKey = key.replace('_CustomCSS', '');
                root.style.setProperty(`--${newKey}`, value as string);
            }else{
                root.style.setProperty(`--${key.replace('_CustomCSS', '')}`, defaults[key as keyof typeof defaults]);
            }
        }
    }
};


export const getIVRInformationTemplate = async ( authFieldsVal: { [key: string]: string }, authType:string, chatUUID: string, pgm: string, convId: string, msal?: any, settings?: any): Promise<Response> => {
    let body;
    // The B2C token lets the Auth API verify the caller for the case summary
    const accessToken = msal ? await getAccessToken(msal, settings) : null;
     
    const { env, isInIframe } = getEnvContext();
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    body = JSON.stringify({
        conversation_id: convId,
        user_id: chatUUID,
        pgm: pgm,
        // Same as historyGenerate: the "profile" prefix is a sign-in concept, the backend only knows the flow
        authType: authType.replace(/^profile/, ''),
        authFieldsVal: authFieldsVal,
        env,
        isInIframe,
        config_code: configCode
    })

    const response = await fetch("/signon/informationTemplate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
        },
        body: body
    }).then((res) => {
        return res
    })
        .catch((err) => {
            console.error("There was an issue getting IVR information template. " + err);

            return new Response(null, { status: 500 });
        })
    return response
}

// The profile pane's Case Summary text; null when it can't be generated
export const getCaseSummary = async (caseNumber: string, chatUUID: string, pgm: string, convId: string, msal: any, settings: any): Promise<string | null> => {
    try {
        const accessToken = await getAccessToken(msal, settings);
        const { env, isInIframe } = getEnvContext();
        const response = await fetch("/signon/caseSummary", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {})
            },
            body: JSON.stringify({
                conversation_id: convId,
                user_id: chatUUID,
                pgm: pgm,
                caseNumber: caseNumber,
                env,
                isInIframe,
                config_code: window.sessionStorage.getItem("selectedProgramConfig")
            })
        });
        if (!response.ok) return null;
        const data = await response.json();
        return data?.summary || null;
    } catch (err) {
        console.error("There was an issue getting the case summary. " + err);
        return null;
    }
}

export const getBlobList = async (forceRefresh: boolean = false, pgm: string, msal: any, settings: any): Promise<BlobListItem[] | null> => {
    const { env, isInIframe } = getEnvContext();
    const accessToken = await getAccessToken(msal, settings);
    const sessionToken = await getCachedSessionToken(msal, settings);
    const requestHeaders: Record<string, string> = {
        "Content-Type": "application/json",
        ...(accessToken ? { "Authorization": `Bearer ${accessToken}` } : {}),
        ...(sessionToken ? { "X-Session-Token": sessionToken } : {})
    };
    const configCode = window.sessionStorage.getItem("selectedProgramConfig")
    const requestBody = {
        pgm: pgm,
        env,
        isInIframe,
        force_refresh: forceRefresh,
        config_code: configCode
    };

    const response = await fetch(`/bloblist`, {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: requestHeaders
    }).then(async (res) => {
        const payload = await res.json();
        if (!Array.isArray(payload)) {
            console.error("There was an issue fetching your document.");
            return null;
        }

        const acl: BlobListItem[] = await Promise.all(payload.map(async (conv: BlobListItem) => {
            const item: BlobListItem = conv
            //console.log("conv: " + conv.key)
            return item;
        }));
        //console.log("acl: " + acl)
        return acl;
    }).catch((err) => {
        console.log(err)
        console.error("There was an issue fetching your documents.");
        return null
    })

    return response
}


// B2C Internal Program Authentication API Functions

/**
 * Assign user to a program's security group (programGroup).
 * @param programConfigCode The program's environment config code (e.g., "SNAP-DEV")
 * @param msal MSAL instance for acquiring access token
 * @param settings Settings for which to get the access token
 * @param programId The program's unique Cosmos record id (e.g., "KS-CSP"). Preferred:
 *                  config codes can be shared across sites, ids cannot.
 */
export const assignUserToProgram = async (
    programConfigCode: string,
    msal?: any,
    settings?: any,
    programId?: string
): Promise<AssignUserToProgramResponse | null> => {
    try {
        const accessToken = await getAccessToken(msal, settings);
        
        const response = await fetch("/assign_user_to_program", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                program_config_code: programConfigCode,
                ...(programId ? { program_id: programId } : {})
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error("Error assigning user to program:", errorData);
            return {
                success: false,
                message: errorData.message || "Failed to assign user to program"
            };
        }

        return await response.json();
    } catch (err) {
        console.error("There was an issue assigning user to program:", err);
        return {
            success: false,
            message: "Network error while assigning user to program"
        };
    }
};

// Teams Auth Token Encryption (for secure transmission between popup and main window)
// Encrypts the access token with Fernet (server-side AES) so it is unreadable to any party
// that does not hold the server-side key, including a malicious Teams opener.
export async function encryptTokenForTeamsAuth(token: object): Promise<string> {
    const response = await fetch("/encrypt-token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to encrypt auth token");
    }

    const { encrypted } = await response.json();
    return encrypted;
}
